/* @flow */
import { fromJS, List, Map } from 'immutable';
import moment from 'moment-timezone';
import { isObject } from 'trustar/utils';

/* Helper for checking if an analysis has a report node */
export const hasReportNode = (graph: any): boolean => {
  return !!(graph.get('nodes').filter(n => n.get('type') === 'INCIDENT_REPORT')).size;
};

/**
 * Convert a raw analysis to immutable and make sure all its x/y values are set
 * to its fx/fy values.
 */
export const analysisToConstellation = (graph: Object): Map<string, *> =>
  fromJS(graph).update('nodes', nodes => nodes.map(x =>
    x.set('x', x.get('fx'))
     .set('y', x.get('fy'))));

export const toJSON = (analysis: Map<any, any>, graph: any) => {
  const nodes = graph.get('nodes', List())
    .map(node => fromJS({
      id: node.get('id'),
      fx: node.get('x'),
      fy: node.get('y'),
      rootNode: node.get('rootNode'),
      nodeType: node.get('nodeType'),
    }))
    .toList();
  const edges = graph.get('edges', List())
    .map(edge => fromJS({
      id: edge.get('id'),
      source: edge.getIn(['source', 'id']),
      target: edge.getIn(['target', 'id']),
    }))
    .toList();

  return Map().withMutations(x => {
    x.set('title', analysis.get('title'));
    x.set('nodes', nodes);
    x.set('edges', edges);
  });
};

// TODO: Couldn't we simply do something like?
// `https://${window.location.host}/constellation/analysis/${guid}`
// Also, since this is derived data we can probably simplify by not storing it
// on the data record itself.
//
// TODO: None of the other data records in our system (AFAIK) use `guid` let's
// map guid -> id.
export const fromJSON = (rawAnalysis: any) => {
  const analysis = fromJS(rawAnalysis);
  const guid = analysis.get('guid');
  const serverName = window.location.hostname;
  let shareableLink = `https://station.trustar.co/constellation/analysis/${guid}`;

  if (serverName.indexOf('localhost') >= 0 || serverName.indexOf('staging') >= 0) {
    shareableLink = `https://staging.trustar.co/constellation/analysis/${guid}`;
  } else if (serverName.indexOf('demo') >= 0) {
    shareableLink = `https://demo.trustar.co/constellation/analysis/${guid}`;
  }

  return analysis.mapEntries(([k, v]) => {
    switch (k) {
    case 'created':
    case 'updated':
      return [k, moment(v)];
    case 'nodes':
    case 'edges':
      return [k, List()]; // Why an _empty_ list?
    case 'sharedWith':
      const emails = v.map(x => isObject(x) ? x.get('email') : x);
      return [k, emails.join(', ')];
    case 'createdBy':
    case 'updatedBy':
      return null;
    case 'user':
      return isObject(v) ? [k, v.get('email')] : [k, v];
    default:
      return [k, v];
    }
  }).set('url', shareableLink);
};



// WEBPACK FOOTER //
// ./src/app/modules/analysis/utils.js